const SETTINGS_KEY = 'northai-settings';

export const translations = {
  en: {
    loadingApp: 'Loading...',
    newConversationTitle: 'New conversation',
    modelBadgeTitle: 'Model: Luruz',
    longWaitNotice: 'We apologize, this is taking longer than expected.',
    brainShow: 'See the brain',
    brainHide: 'Hide the brain',
    errorProcessing: 'Sorry, there was an error processing your request.',
    chatEmptyGreeting: 'How can I help you today?',
    typeQuestionPlaceholder: 'Type your question here...',
    sourcesLabel: 'Sources:',
    copyCode: 'Copy',
    copied: 'Copied',
    showPreview: 'Preview',
    hidePreview: 'Hide preview',
    showFullPreview: 'Preview full page',
    hideFullPreview: 'Hide full page preview',
    clickToView: 'Click to view',
    noMessages: 'No messages',
    sendMessageAria: 'Send message',
    stopGeneratingAria: 'Stop generating',
    attachFileAria: 'Attach',
    attachImages: 'Images',
    attachVideos: 'Videos',
    attachFiles: 'Files',
    micAria: 'Voice input',
    screenShareAria: 'Share your screen',
    stopScreenShareAria: 'Stop sharing your screen',
    screenSharing: 'Sharing your screen',
    readAloud: 'Read replies aloud',
    on: 'On',
    off: 'Off',
    describeAttachmentFallback: 'Describe what you see.',
    attachmentLimitReached: "You've reached the attachment limit.",
    attachmentTooLarge: 'That file is too large to attach.',
    removeAttachmentAria: 'Remove attachment',
    speakMessageAria: 'Read this message aloud',
    likeMessageAria: 'Good response',
    dislikeMessageAria: 'Bad response',
    retryMessageAria: 'Retry',
    copyMessageAria: 'Copy response',
    shareMessageAria: 'Share response',
    stopVoiceModeAria: 'Stop voice mode',
    voiceModeListening: 'Listening…',
    voiceModeThinking: 'Thinking…',
    voiceModeSearching: 'Searching the web…',
    voiceModeSpeaking: 'Speaking… just start talking to interrupt',
    voiceMicDenied: 'Allow microphone access to talk with wheniseeus.',
    voiceUnavailable: "Voice conversation isn't available right now. Please try again later.",
    voicePlanRequired: 'Voice conversation requires the Pro or Premium plan.',
    voiceLabel: 'Voice',
    voiceAuto: 'Automatic (best available)',

    showcaseHeadingLine1: 'Talk to your AI assistant,',
    showcaseHeadingLine2: 'built for your whole team.',
    showcaseTeamCaption: 'Now with team workspaces',
    showcaseAiBubble1: 'Hi! How can I help the team?',
    showcaseUserBubble: 'Give me ideas for our project',
    showcaseAiBubble2: "On it — tagging this for Sam",

    emailPlaceholder: 'Email',
    passwordPlaceholder: 'Password',
    confirmPasswordPlaceholder: 'Confirm password',
    showPassword: 'Show password',
    hidePassword: 'Hide password',
    termsAcceptPrefix: 'I accept the',
    termsAndConditions: 'Terms and Conditions',
    termsMidPrivacy: 'the',
    privacyPolicy: 'Privacy Policy',
    termsMidRefund: 'and the',
    refundPolicy: 'Refund Policy',

    resetPasswordSent: 'We sent you an email to reset your password.',
    enterEmailToReset: 'Enter your email to reset your password.',
    processing: 'Processing...',
    logIn: 'Log in',
    createAccount: 'Create account',
    forgotPassword: 'Forgot your password?',
    noAccount: "Don't have an account?",
    signUp: 'Sign up',
    alreadyHaveAccount: 'Already have an account?',

    errIncorrectCredentials: 'Incorrect email or password.',
    errCantCreateAccount: "Couldn't create the account with that information.",
    errEmailInUse: 'That email is already registered. Log in or use a different email.',
    errInvalidEmail: "That email isn't valid.",
    errWeakPassword: 'That password is too weak. Use at least 6 characters.',
    errTooManyRequests: 'Too many attempts. Wait a few minutes and try again.',
    errNetwork: 'No connection. Check your internet and try again.',
    errEmailPasswordDisabled: "Email/Password isn't enabled in Firebase Auth.",
    errGenericAuth: "Couldn't complete authentication.",
    errGoogleAccountExists: 'That email already has an account with a password. Log in with your email and password.',
    errGoogleUnauthorizedDomain: "Google sign-in isn't enabled for this address. Use wheniseeus.com.",
    errGooglePopupBlocked: 'Your browser blocked the Google window. Allow pop-ups for this site and try again.',
    orDivider: 'or',
    continueWithGoogle: 'Continue with Google',
    googleTermsPrefix: 'By continuing with Google you accept the',
    googleTermsAnd: 'and the',
    errEnterEmailPassword: 'Enter your email and password.',
    errPasswordsMismatch: "Passwords don't match.",
    errMustAcceptTerms: 'You must accept the Terms and Conditions, Privacy Policy, and Refund Policy.',
    errSignOut: "Couldn't sign out.",

    menuTitle: 'Menu',
    openMenuAria: 'Open menu',
    closeMenuAria: 'Close menu',
    menuHistory: 'History',
    menuSettings: 'Settings',
    menuSupport: 'Support',
    menuAccount: 'Account',

    closeHistoryAria: 'Close history',
    deleteConversationTitle: 'Delete conversation',

    appearance: 'Appearance',
    theme: 'Theme',
    light: 'Light',
    dark: 'Dark',
    themeAuto: 'Auto',
    textSize: 'Text size',
    language: 'Language',
    chatSection: 'Chat',
    deleteAllHistory: 'Delete all history',
    delete: 'Delete',
    confirmDeleteHistory: 'Delete all history? This action cannot be undone.',
    exportAllConversations: 'Export all conversations',
    exportCurrentConversation: 'Export current conversation',
    exportNothing: 'There are no conversations to export yet.',
    exportYou: 'You',
    resetSettings: 'Restore default settings',
    reset: 'Restore',
    confirmResetSettings: 'Restore theme, text size and voice settings to their defaults?',
    subscriptionSection: 'Subscription',
    managePlan: 'Manage plan',
    view: 'View',
    about: 'About',
    poweredBy: 'Powered by Dapur Tecnología',
    close: 'Close',

    accountTitle: 'Account',
    signedInAs: 'Signed in as',
    authenticatedUser: 'Authenticated user',
    signOut: 'Sign out',

    supportIntro: "Have a question or need help? Tell us what's going on and we'll get back to you soon.",
    supportSentMsg: "Done! We received your message and will reply by email.",
    namePlaceholder: 'Name',
    messagePlaceholder: 'Tell us how we can help...',
    errSupportRequired: 'Enter your name, email, and a message of at least 5 characters.',
    errSupportSend: "Couldn't send the message. Try again later.",
    sending: 'Sending...',
    sendMessage: 'Send message',

    backAria: 'Back',
    subscribeTitle: 'Subscribe',
    loadingEllipsis: 'Loading…',
    activeBadge: 'Active',
    proPlanActiveTitle: 'Pro plan active',
    proPlanActiveDesc: 'Your subscription is active. Enjoy all the features.',
    proLabel: 'Pro',
    perMonth: '/ month',
    planBasicoName: 'Basic',
    planProName: 'Plus',
    planPremiumName: 'Pro',
    mostPopular: 'Most popular',
    cancelToSwitchPlan: 'Cancel your current plan to switch to this one.',
    featureUnlimitedMessages: 'Unlimited messages',
    featureBasicoMessages: '20 messages per day',
    featureBasicoTextOnly: 'Text only (no voice or image understanding)',
    featureVoiceVision: 'Voice mode and image understanding',
    featureMorePremiumAttachments: 'Up to 8 attachments per message',
    featureMoreContext: 'Answers with more context',
    featurePriorityAccess: 'Priority access to new features',
    planCodersName: 'Coders',
    forDevelopers: 'For developers',
    vscodeExtensionLink: 'VS Code extension',
    remoteTitle: 'Remote VS Code',
    remoteIntro: 'Work on the VS Code on your computer from here: ask about your code or request changes. It asks you when something is unclear, and code changes are only applied when you approve them.',
    remoteNoDevices: 'No VS Code connected yet. Install the extension and sign in on your computer.',
    remoteOnline: 'Online',
    remoteOffline: 'Offline',
    remoteOfflineHint: 'This VS Code is closed. Your message will be answered when you open it again.',
    remoteEmptyChat: 'Try: "what does this file do?", "fix the error in the open file", "create a test for login", "delete the old config file", "run the tests"…',
    remotePlaceholder: 'Write to your VS Code…',
    remoteSend: 'Send',
    remoteStatusSent: 'Sent to VS Code',
    remoteStatusQueued: 'Waiting for VS Code to open',
    remoteStatusThinking: 'VS Code is answering…',
    remoteStatusError: 'Could not answer',
    remoteErrLoad: 'Could not load your VS Code sessions.',
    remoteErrSend: 'Could not send the message.',
    remoteQuestionLabel: 'VS Code asks:',
    remoteEditCreate: 'Create',
    remoteEditModify: 'Change',
    remoteEditRewrite: 'Rewrite',
    remoteEditDelete: 'Delete',
    remoteEditDeleteNote: 'This file will be moved to the trash on your computer.',
    remoteApply: 'Apply',
    remotePinPlaceholder: 'VS Code remote PIN',
    remoteConfirm: 'Confirm',
    remoteTermsNote: 'Changes and commands are AI suggestions: you review and approve each one, under your responsibility. Keep your code in git or backed up.',
    remoteTermsLink: 'Terms, section 6',
    remoteReviewPending: 'There are changes made from here that haven\'t been reviewed on the computer yet. Until they are (VS Code: "Wheniseeus: Revisar cambios remotos"), only read-only commands like git status or git diff can run.',
    remoteNoEditAndRun: 'For safety, a proposal can\'t change files and run code-running commands together. Apply the changes, review them on the computer, then ask for the commands.',
    remoteNeedPin: 'Set a PIN for this computer first to apply changes from here.',
    remotePinLink: 'Set up PIN',
    pinSection: 'Remote VS Code · PIN',
    pinSectionHint: 'The PIN approves, from your phone, the changes and commands VS Code proposes. It is stored only on your computer: the button opens the PIN box in VS Code, and you type it there.',
    pinSignIn: 'Sign in to see your computers.',
    pinStatusSet: 'PIN set',
    pinStatusMissing: 'No PIN',
    pinStatusLocked: 'Locked after wrong PINs - unlock it in VS Code',
    pinSet: 'Set PIN',
    pinChange: 'Change PIN',
    pinRequested: 'Done - type the PIN in VS Code on your computer.',
    pinNeedsOnline: 'Open VS Code on that computer first',
    pinNotPickedUp: 'VS Code did not respond. Update the Wheniseeus extension (0.6.13 or newer), reload the window and try again.',
    remoteLocked: 'Remote changes are locked after several wrong PINs. Unlock them in VS Code.',
    remoteCommandsOff: 'The remote terminal is off in VS Code (setting wheniseeus.remote.allowCommands), so these commands won\'t run.',
    remoteApplyAndRun: 'Apply and run',
    remoteCommandsLabel: 'Commands to run in the terminal:',
    remoteCommandOk: 'OK',
    remoteCommandFailed: 'Failed',
    remoteNoOutput: '(no output)',
    remoteDiscard: 'Discard',
    remoteApplying: 'Applying on your computer…',
    remoteApplied: 'Applied in VS Code',
    remoteRejected: 'Discarded',
    remoteApplyFailed: 'Could not apply',
    featureNoLimits: 'No limits: unlimited messages',
    featureVscode: 'Wheniseeus in VS Code (chat, ask about your code, workspaces)',
    featureLongReplies: 'Long answers with room for whole files of code',
    featureWorkspacesEverywhere: 'Workspaces on the web and in VS Code',
    comingSoon: 'Coming soon',
    featureNoInterruptions: 'No interruptions',
    featurePrioritySupport: 'Priority support',
    activeSubscription: 'Active subscription',
    backToChat: 'Back to chat',
    cancelSubscription: 'Cancel subscription',
    cancelConfirmText: "Cancel your Pro subscription? This will cancel the automatic charge on PayPal immediately and you'll lose access to Pro features.",
    yesCancelSubscription: 'Yes, cancel subscription',
    cancelling: 'Cancelling…',
    cancelErrorSuffix: 'If the problem persists, cancel manually from',
    yourPaypalAccount: 'your PayPal account',
    errCancelSubscription: "Couldn't cancel the subscription automatically.",
    errSessionExpired: 'Session expired. Log in again.',
    requiredBadge: 'Required',
    subscriptionRequiredTitle: 'Subscription required',
    subscriptionRequiredDesc: 'You need a Pro subscription to use wheniseeus.',
    loadingPaypal: 'Loading PayPal…',
    cancelAnytimeNote: 'Cancel anytime · No hidden fees',
    errPaypalLoad: "Couldn't load PayPal. Check your connection.",
    errPaypalApprovedButFailed: "Payment approved, but couldn't activate it. Contact support.",
    errPaypalGeneric: 'Something went wrong with PayPal. Try again.',
    workspacesTitle: 'Workspaces',
    createWorkspace: 'Create workspace',
    workspaceNamePlaceholder: 'Workspace name',
    joinWorkspace: 'Join with a code',
    joinCodePlaceholder: 'Enter code',
    join: 'Join',
    noWorkspaces: "You're not in any workspace yet.",
    membersTitle: 'Members',
    inviteByEmail: 'Invite by email',
    inviteEmailPlaceholder: 'Email address',
    invite: 'Invite',
    inviteSentPrefix: 'Invite sent. Code:',
    inviteShareCodePrefix: "Invite created, but the email couldn't be sent. Share this code with them:",
    workModeLabel: 'Work mode',
    chatModeLabel: 'Normal chat',
    workspaceChatPlaceholder: 'Message the group...',
    backToWorkspaces: 'Back to workspaces',
    toggleWorkspaceMenu: 'Toggle workspace menu',
    enableNotificationsAria: 'Enable notifications for this workspace',
    disableNotificationsAria: 'Disable notifications for this workspace',
    adminBadge: 'Admin',
    youBadge: 'You',
    errCreateWorkspace: "Couldn't create the workspace.",
    errJoinWorkspace: "Couldn't join with that code.",
    errInvite: "Couldn't send the invite.",
    errLoadWorkspace: "Couldn't load this workspace.",
    sendLabel: 'Send',
    errSendMessage: "Couldn't send the message. Try again.",
    filesTitle: 'Files',
    uploadFile: 'Upload',
    uploading: 'Uploading...',
    noFiles: 'No files shared yet.',
    errUploadFile: "Couldn't upload the file.",
    deleteFileAria: 'Delete file',
    confirmDeleteFile: 'Delete this file for everyone in the group?',
    viewFileAria: 'View',
    copyLinkAria: 'Copy link',
    downloadFileAria: 'Download',
    deleteWorkspace: 'Delete group',
    deleting: 'Deleting...',
    confirmDeleteWorkspace: 'Delete this group for everyone? This deletes the chat, tasks and files, and can\'t be undone.',
    errDeleteWorkspace: "Couldn't delete the group.",
    tasksTitle: 'Tasks',
    taskFilterAll: 'All',
    taskFilterMine: 'Mine',
    noTasks: 'No tasks yet.',
    assignTaskPlaceholder: 'Assign to...',
    taskAssignedBadgePrefix: 'Task for',
    voiceChannelTitle: 'Voice channel',
    joinVoice: 'Join voice',
    leaveVoice: 'Leave voice',
    muteLabel: 'Mute',
    unmuteLabel: 'Unmute',
    mutedBadge: 'Muted',
    errVoiceMic: "Couldn't access your microphone.",
    installTitle: 'Install wheniseeus',
    installReady: 'Get wheniseeus with its own icon and window, like any other app.',
    installButton: 'Install',
    installDone: 'Done! wheniseeus is installed. Look for its icon on your device.',
    installIosStep1: 'Tap Share (the square with an arrow pointing up).',
    installIosStep2: 'Scroll down and tap "Add to Home Screen".',
    installIosStep3: 'Tap "Add".',
    installIosOther: 'To install it on iPhone or iPad, open wheniseeus.com in Safari, tap Share and then "Add to Home Screen".',
    installMacSafari: 'In Safari, choose File → "Add to Dock".',
    installFirefox: "Firefox can't install web apps. Open wheniseeus.com in Chrome or Edge to install it.",
    installMenu: 'Use the install icon in the address bar, or open the browser menu and choose "Install app" or "Add to Home screen".'
  },
  es: {
    loadingApp: 'Cargando...',
    newConversationTitle: 'Nueva conversación',
    modelBadgeTitle: 'Modelo: Luruz',
    longWaitNotice: 'Te pedimos disculpas, esto está tardando más de lo esperado.',
    brainShow: 'Ver el cerebro',
    brainHide: 'Ocultar el cerebro',
    errorProcessing: 'Lo siento, ocurrió un error al procesar tu solicitud.',
    chatEmptyGreeting: '¿En qué puedo ayudarte hoy?',
    typeQuestionPlaceholder: 'Escribe tu pregunta aquí...',
    sourcesLabel: 'Fuentes:',
    copyCode: 'Copiar',
    copied: 'Copiado',
    showPreview: 'Vista previa',
    hidePreview: 'Ocultar vista previa',
    showFullPreview: 'Vista previa de la página completa',
    hideFullPreview: 'Ocultar vista previa completa',
    clickToView: 'Click para ver',
    noMessages: 'Sin mensajes',
    sendMessageAria: 'Enviar mensaje',
    stopGeneratingAria: 'Detener generación',
    attachFileAria: 'Adjuntar',
    attachImages: 'Imágenes',
    attachVideos: 'Videos',
    attachFiles: 'Archivos',
    micAria: 'Entrada de voz',
    screenShareAria: 'Compartir tu pantalla',
    stopScreenShareAria: 'Dejar de compartir tu pantalla',
    screenSharing: 'Compartiendo tu pantalla',
    readAloud: 'Leer respuestas en voz alta',
    on: 'Activado',
    off: 'Desactivado',
    describeAttachmentFallback: 'Describe lo que ves.',
    attachmentLimitReached: 'Alcanzaste el límite de adjuntos.',
    attachmentTooLarge: 'Ese archivo es demasiado grande para adjuntar.',
    removeAttachmentAria: 'Quitar adjunto',
    speakMessageAria: 'Leer este mensaje en voz alta',
    likeMessageAria: 'Buena respuesta',
    dislikeMessageAria: 'Mala respuesta',
    retryMessageAria: 'Reintentar',
    copyMessageAria: 'Copiar respuesta',
    shareMessageAria: 'Compartir respuesta',
    stopVoiceModeAria: 'Detener modo de voz',
    voiceModeListening: 'Escuchando…',
    voiceModeThinking: 'Pensando…',
    voiceModeSearching: 'Buscando en internet…',
    voiceModeSpeaking: 'Hablando… empezá a hablar para interrumpir',
    voiceMicDenied: 'Permití el acceso al micrófono para hablar con wheniseeus.',
    voiceUnavailable: 'La conversación por voz no está disponible en este momento. Probá más tarde.',
    voicePlanRequired: 'La conversación por voz requiere el plan Pro o Premium.',
    voiceLabel: 'Voz',
    voiceAuto: 'Automática (mejor disponible)',

    showcaseHeadingLine1: 'Habla con tu asistente de IA,',
    showcaseHeadingLine2: 'hecho para todo tu equipo.',
    showcaseTeamCaption: 'Ahora con espacios de equipo',
    showcaseAiBubble1: '¡Hola! ¿En qué ayudo al equipo?',
    showcaseUserBubble: 'Dame ideas para nuestro proyecto',
    showcaseAiBubble2: 'Dale — se lo asigno a Sam',

    emailPlaceholder: 'Correo electrónico',
    passwordPlaceholder: 'Contraseña',
    confirmPasswordPlaceholder: 'Confirmar contraseña',
    showPassword: 'Mostrar contraseña',
    hidePassword: 'Ocultar contraseña',
    termsAcceptPrefix: 'Acepto los',
    termsAndConditions: 'Términos y condiciones',
    termsMidPrivacy: 'la',
    privacyPolicy: 'Política de privacidad',
    termsMidRefund: 'y la',
    refundPolicy: 'Política de reembolsos',

    resetPasswordSent: 'Te enviamos un correo para restablecer tu contraseña.',
    enterEmailToReset: 'Ingresa tu correo para restablecer tu contraseña.',
    processing: 'Procesando...',
    logIn: 'Iniciar sesión',
    createAccount: 'Crear cuenta',
    forgotPassword: '¿Olvidaste tu contraseña?',
    noAccount: '¿No tienes cuenta?',
    signUp: 'Regístrate',
    alreadyHaveAccount: '¿Ya tienes cuenta?',

    errIncorrectCredentials: 'Correo o contraseña incorrectos.',
    errCantCreateAccount: 'No se pudo crear la cuenta con esa información.',
    errEmailInUse: 'Ese correo ya está registrado. Inicia sesión o usa otro correo.',
    errInvalidEmail: 'Ese correo no es válido.',
    errWeakPassword: 'Esa contraseña es muy débil. Usa al menos 6 caracteres.',
    errTooManyRequests: 'Demasiados intentos. Espera unos minutos e intenta de nuevo.',
    errNetwork: 'Sin conexión. Revisa tu internet e intenta de nuevo.',
    errEmailPasswordDisabled: 'Email/Password no está habilitado en Firebase Auth.',
    errGenericAuth: 'No se pudo completar la autenticación.',
    errGoogleAccountExists: 'Ese email ya tiene una cuenta con contraseña. Inicia sesión con tu email y contraseña.',
    errGoogleUnauthorizedDomain: 'El inicio de sesión con Google no está habilitado en esta dirección. Usa wheniseeus.com.',
    errGooglePopupBlocked: 'Tu navegador bloqueó la ventana de Google. Permite las ventanas emergentes en este sitio y vuelve a intentarlo.',
    orDivider: 'o',
    continueWithGoogle: 'Continuar con Google',
    googleTermsPrefix: 'Al continuar con Google aceptas los',
    googleTermsAnd: 'y la',
    errEnterEmailPassword: 'Ingresa tu correo y contraseña.',
    errPasswordsMismatch: 'Las contraseñas no coinciden.',
    errMustAcceptTerms: 'Debes aceptar los Términos y condiciones, la Política de privacidad y la Política de reembolsos.',
    errSignOut: 'No se pudo cerrar sesión.',

    menuTitle: 'Menú',
    openMenuAria: 'Abrir menú',
    closeMenuAria: 'Cerrar menú',
    menuHistory: 'Historial',
    menuSettings: 'Configuración',
    menuSupport: 'Soporte',
    menuAccount: 'Cuenta',

    closeHistoryAria: 'Cerrar historial',
    deleteConversationTitle: 'Eliminar conversación',

    appearance: 'Apariencia',
    theme: 'Tema',
    light: 'Claro',
    dark: 'Oscuro',
    themeAuto: 'Auto',
    textSize: 'Tamaño de texto',
    language: 'Idioma',
    chatSection: 'Chat',
    deleteAllHistory: 'Eliminar todo el historial',
    delete: 'Eliminar',
    confirmDeleteHistory: '¿Eliminar todo el historial? Esta acción no se puede deshacer.',
    exportAllConversations: 'Exportar todas las conversaciones',
    exportCurrentConversation: 'Exportar conversación actual',
    exportNothing: 'Todavía no hay conversaciones para exportar.',
    exportYou: 'Vos',
    resetSettings: 'Restablecer configuración',
    reset: 'Restablecer',
    confirmResetSettings: '¿Restablecer el tema, el tamaño de texto y la voz a sus valores predeterminados?',
    subscriptionSection: 'Suscripción',
    managePlan: 'Gestionar plan',
    view: 'Ver',
    about: 'Acerca de',
    poweredBy: 'Desarrollado por Dapur Tecnología',
    close: 'Cerrar',

    accountTitle: 'Cuenta',
    signedInAs: 'Sesión iniciada como',
    authenticatedUser: 'Usuario autenticado',
    signOut: 'Cerrar sesión',

    supportIntro: '¿Tienes una pregunta o necesitas ayuda? Cuéntanos qué sucede y te responderemos pronto.',
    supportSentMsg: '¡Listo! Recibimos tu mensaje y te responderemos por correo.',
    namePlaceholder: 'Nombre',
    messagePlaceholder: 'Cuéntanos cómo podemos ayudarte...',
    errSupportRequired: 'Ingresa tu nombre, correo y un mensaje de al menos 5 caracteres.',
    errSupportSend: 'No se pudo enviar el mensaje. Intenta de nuevo más tarde.',
    sending: 'Enviando...',
    sendMessage: 'Enviar mensaje',

    backAria: 'Atrás',
    subscribeTitle: 'Suscripción',
    loadingEllipsis: 'Cargando…',
    activeBadge: 'Activo',
    proPlanActiveTitle: 'Plan Pro activo',
    proPlanActiveDesc: 'Tu suscripción está activa. Disfruta todas las funciones.',
    proLabel: 'Pro',
    perMonth: '/ mes',
    planBasicoName: 'Básico',
    planProName: 'Plus',
    planPremiumName: 'Pro',
    mostPopular: 'Más elegido',
    cancelToSwitchPlan: 'Cancelá tu plan actual para cambiarte a este.',
    featureUnlimitedMessages: 'Mensajes ilimitados',
    featureBasicoMessages: '20 mensajes por día',
    featureBasicoTextOnly: 'Solo texto (sin voz ni comprensión de imágenes)',
    featureVoiceVision: 'Modo de voz y comprensión de imágenes',
    featureMorePremiumAttachments: 'Hasta 8 adjuntos por mensaje',
    featureMoreContext: 'Respuestas con más contexto',
    featurePriorityAccess: 'Acceso prioritario a nuevas funciones',
    planCodersName: 'Coders',
    forDevelopers: 'Para programadores',
    vscodeExtensionLink: 'Extensión para VS Code',
    remoteTitle: 'VS Code remoto',
    remoteIntro: 'Trabaja desde aquí en el VS Code de tu computadora: pregúntale sobre tu código o pídele cambios. Si algo no está claro te pregunta, y los cambios de código solo se aplican cuando los apruebas.',
    remoteNoDevices: 'Todavía no hay ningún VS Code conectado. Instala la extensión e inicia sesión en tu computadora.',
    remoteOnline: 'Conectado',
    remoteOffline: 'Desconectado',
    remoteOfflineHint: 'Este VS Code está cerrado. Tu mensaje se responderá cuando lo vuelvas a abrir.',
    remoteEmptyChat: 'Prueba: "¿qué hace este archivo?", "arregla el error del archivo abierto", "crea un test para el login", "elimina el archivo de config viejo", "corre los tests"…',
    remotePlaceholder: 'Escríbele a tu VS Code…',
    remoteSend: 'Enviar',
    remoteStatusSent: 'Enviado a VS Code',
    remoteStatusQueued: 'Esperando a que abras VS Code',
    remoteStatusThinking: 'VS Code está respondiendo…',
    remoteStatusError: 'No se pudo responder',
    remoteErrLoad: 'No se pudieron cargar tus sesiones de VS Code.',
    remoteErrSend: 'No se pudo enviar el mensaje.',
    remoteQuestionLabel: 'VS Code pregunta:',
    remoteEditCreate: 'Crear',
    remoteEditModify: 'Modificar',
    remoteEditRewrite: 'Reescribir',
    remoteEditDelete: 'Eliminar',
    remoteEditDeleteNote: 'Este archivo se moverá a la papelera de tu computadora.',
    remoteApply: 'Aplicar',
    remotePinPlaceholder: 'PIN de VS Code remoto',
    remoteConfirm: 'Confirmar',
    remoteTermsNote: 'Los cambios y comandos son sugerencias de una IA: tú revisas y apruebas cada uno, bajo tu responsabilidad. Mantén tu código en git o con copias de seguridad.',
    remoteTermsLink: 'Términos, sección 6',
    remoteReviewPending: 'Hay cambios hechos desde aquí sin revisar en la computadora. Hasta que los revises (en VS Code: "Wheniseeus: Revisar cambios remotos"), solo se pueden ejecutar comandos de solo lectura como git status o git diff.',
    remoteNoEditAndRun: 'Por seguridad, una propuesta no puede cambiar archivos y ejecutar comandos que corren código a la vez. Aplica los cambios, revísalos en la computadora y después pide los comandos.',
    remoteNeedPin: 'Primero configura un PIN para esta computadora para aplicar cambios desde aquí.',
    remotePinLink: 'Configurar PIN',
    pinSection: 'VS Code remoto · PIN',
    pinSectionHint: 'El PIN aprueba desde el celular los cambios y comandos que propone VS Code. Se guarda solo en tu computadora: el botón abre la ventana del PIN en VS Code y lo escribes ahí.',
    pinSignIn: 'Inicia sesión para ver tus computadoras.',
    pinStatusSet: 'PIN configurado',
    pinStatusMissing: 'Sin PIN',
    pinStatusLocked: 'Bloqueado por PIN incorrectos: desbloquéalo en VS Code',
    pinSet: 'Configurar PIN',
    pinChange: 'Cambiar PIN',
    pinRequested: 'Listo: escribe el PIN en VS Code, en tu computadora.',
    pinNeedsOnline: 'Primero abre VS Code en esa computadora',
    pinNotPickedUp: 'VS Code no respondió. Actualiza la extensión Wheniseeus (0.6.13 o más nueva), recarga la ventana y vuelve a intentarlo.',
    remoteLocked: 'Los cambios remotos están bloqueados por varios PIN incorrectos. Desbloquéalos en VS Code.',
    remoteCommandsOff: 'La terminal remota está desactivada en VS Code (ajuste wheniseeus.remote.allowCommands), así que estos comandos no se van a ejecutar.',
    remoteApplyAndRun: 'Aplicar y ejecutar',
    remoteCommandsLabel: 'Comandos a ejecutar en la terminal:',
    remoteCommandOk: 'OK',
    remoteCommandFailed: 'Falló',
    remoteNoOutput: '(sin salida)',
    remoteDiscard: 'Descartar',
    remoteApplying: 'Aplicando en tu computadora…',
    remoteApplied: 'Aplicado en VS Code',
    remoteRejected: 'Descartado',
    remoteApplyFailed: 'No se pudo aplicar',
    featureNoLimits: 'Sin límites: mensajes ilimitados',
    featureVscode: 'Wheniseeus en VS Code (chat, preguntas sobre tu código, espacios)',
    featureLongReplies: 'Respuestas largas, con espacio para archivos de código completos',
    featureWorkspacesEverywhere: 'Espacios de trabajo en la web y en VS Code',
    comingSoon: 'Próximamente',
    featureNoInterruptions: 'Sin interrupciones',
    featurePrioritySupport: 'Soporte prioritario',
    activeSubscription: 'Suscripción activa',
    backToChat: 'Volver al chat',
    cancelSubscription: 'Cancelar suscripción',
    cancelConfirmText: '¿Cancelar tu suscripción Pro? Esto cancelará el cobro automático en PayPal de inmediato y perderás el acceso a las funciones Pro.',
    yesCancelSubscription: 'Sí, cancelar suscripción',
    cancelling: 'Cancelando…',
    cancelErrorSuffix: 'Si el problema persiste, cancela manualmente desde',
    yourPaypalAccount: 'tu cuenta de PayPal',
    errCancelSubscription: 'No se pudo cancelar la suscripción automáticamente.',
    errSessionExpired: 'Sesión expirada. Inicia sesión de nuevo.',
    requiredBadge: 'Requerido',
    subscriptionRequiredTitle: 'Suscripción requerida',
    subscriptionRequiredDesc: 'Necesitas una suscripción Pro para usar wheniseeus.',
    loadingPaypal: 'Cargando PayPal…',
    cancelAnytimeNote: 'Cancela cuando quieras · Sin cargos ocultos',
    errPaypalLoad: 'No se pudo cargar PayPal. Revisa tu conexión.',
    errPaypalApprovedButFailed: 'Pago aprobado, pero no se pudo activar. Contacta a soporte.',
    errPaypalGeneric: 'Algo salió mal con PayPal. Intenta de nuevo.',
    workspacesTitle: 'Espacios de trabajo',
    createWorkspace: 'Crear espacio de trabajo',
    workspaceNamePlaceholder: 'Nombre del espacio',
    joinWorkspace: 'Unirse con un código',
    joinCodePlaceholder: 'Ingresá el código',
    join: 'Unirse',
    noWorkspaces: 'Todavía no estás en ningún espacio de trabajo.',
    membersTitle: 'Miembros',
    inviteByEmail: 'Invitar por email',
    inviteEmailPlaceholder: 'Correo electrónico',
    invite: 'Invitar',
    inviteSentPrefix: 'Invitación enviada. Código:',
    inviteShareCodePrefix: 'Invitación creada, pero no se pudo enviar el email. Compartile este código:',
    workModeLabel: 'Modo trabajo',
    chatModeLabel: 'Chat normal',
    workspaceChatPlaceholder: 'Escribile al grupo...',
    backToWorkspaces: 'Volver a espacios de trabajo',
    toggleWorkspaceMenu: 'Mostrar/ocultar menú del espacio',
    enableNotificationsAria: 'Activar notificaciones de este espacio de trabajo',
    disableNotificationsAria: 'Desactivar notificaciones de este espacio de trabajo',
    adminBadge: 'Admin',
    youBadge: 'Vos',
    errCreateWorkspace: 'No se pudo crear el espacio de trabajo.',
    errJoinWorkspace: 'No se pudo unir con ese código.',
    errInvite: 'No se pudo enviar la invitación.',
    errLoadWorkspace: 'No se pudo cargar este espacio de trabajo.',
    sendLabel: 'Enviar',
    errSendMessage: 'No se pudo enviar el mensaje. Intentá de nuevo.',
    filesTitle: 'Archivos',
    uploadFile: 'Subir',
    uploading: 'Subiendo...',
    noFiles: 'Todavía no se compartió ningún archivo.',
    errUploadFile: 'No se pudo subir el archivo.',
    deleteFileAria: 'Eliminar archivo',
    confirmDeleteFile: '¿Eliminar este archivo para todo el grupo?',
    viewFileAria: 'Ver',
    copyLinkAria: 'Copiar link',
    downloadFileAria: 'Descargar',
    deleteWorkspace: 'Eliminar grupo',
    deleting: 'Eliminando...',
    confirmDeleteWorkspace: '¿Eliminar este grupo para todos? Se borran el chat, las tareas y los archivos, y no se puede deshacer.',
    errDeleteWorkspace: 'No se pudo eliminar el grupo.',
    tasksTitle: 'Tareas',
    taskFilterAll: 'Todas',
    taskFilterMine: 'Mías',
    noTasks: 'Todavía no hay tareas.',
    assignTaskPlaceholder: 'Asignar a...',
    taskAssignedBadgePrefix: 'Tarea para',
    voiceChannelTitle: 'Canal de voz',
    joinVoice: 'Unirse a voz',
    leaveVoice: 'Salir de voz',
    muteLabel: 'Silenciar',
    unmuteLabel: 'Activar sonido',
    mutedBadge: 'Silenciado',
    errVoiceMic: 'No se pudo acceder al micrófono.',
    installTitle: 'Instalá wheniseeus',
    installReady: 'Tené wheniseeus con su propio ícono y su propia ventana, como cualquier app.',
    installButton: 'Instalar',
    installDone: '¡Listo! wheniseeus quedó instalada. Buscá su ícono en tu dispositivo.',
    installIosStep1: 'Tocá Compartir (el cuadrado con la flecha hacia arriba).',
    installIosStep2: 'Bajá y tocá «Agregar a inicio».',
    installIosStep3: 'Tocá «Agregar».',
    installIosOther: 'Para instalarla en iPhone o iPad, abrí wheniseeus.com en Safari, tocá Compartir y después «Agregar a inicio».',
    installMacSafari: 'En Safari, elegí Archivo → «Agregar al Dock».',
    installFirefox: 'Firefox no permite instalar apps web. Abrí wheniseeus.com en Chrome o Edge para instalarla.',
    installMenu: 'Usá el ícono de instalar en la barra de direcciones, o abrí el menú del navegador y elegí «Instalar app» o «Agregar a la pantalla principal».'
  }
};

export function getStoredLanguage() {
  try {
    const saved = localStorage.getItem(SETTINGS_KEY);
    if (saved) {
      const parsed = JSON.parse(saved);
      if (parsed.language === 'es' || parsed.language === 'en') {
        return parsed.language;
      }
    }
  } catch {}
  return 'en';
}

export function hasStoredLanguage() {
  try {
    const saved = localStorage.getItem(SETTINGS_KEY);
    const language = saved && JSON.parse(saved).language;
    return language === 'es' || language === 'en';
  } catch {
    return false;
  }
}

export function setStoredLanguage(language) {
  try {
    const saved = localStorage.getItem(SETTINGS_KEY);
    const parsed = saved ? JSON.parse(saved) : {};
    parsed.language = language;
    localStorage.setItem(SETTINGS_KEY, JSON.stringify(parsed));
  } catch {}
}

export function translate(language, key) {
  return (translations[language] && translations[language][key]) || translations.en[key] || key;
}
